export const myErrorHandler = (error: Error, info: { componentStack: string }) => {

}